import { useGetAutoGtBreakdown } from './getAutoGtBreakdown'
import { useGetAutoGtTimeline } from './getAutoGtTimeline'
import { useGetByIdV3 } from './getByIdV3'
import { useGetOrganization } from './getOrganization'
import { training } from './training'
import { useCreate } from './useCreate'
import { useCreatePreview } from './useCreatePreview'
import { useGetById } from './useGetById'
import { useGetByRequestId } from './useGetByRequestId'
import { useGetRejectionReasons } from './useRejectionReasons'
import {
  RESOLVED_ENGAGEMENT_QUALITY_METRICS_INFINITE_KEY,
  RESOLVED_ENGAGEMENT_QUALITY_METRICS_KEY,
  useGetResolved,
  useGetResolvedWithInfiniteQuery,
} from './useResolved'

export const engagement = {
  getById: useGetById,
  createPreview: useCreatePreview,
  create: useCreate,
  v3: {
    getResolved: useGetResolved,
    getResolvedInfinite: useGetResolvedWithInfiniteQuery,
    getById: useGetByIdV3,
    getOrganization: useGetOrganization,
    getAutoGtBreakdown: useGetAutoGtBreakdown,
    getAutoGtTimeline: useGetAutoGtTimeline,
    getByRequestId: useGetByRequestId,
    getRejectionReasons: useGetRejectionReasons,
  },
  training,
  keys: {
    RESOLVED_ENGAGEMENT_QUALITY_METRICS_KEY,
    RESOLVED_ENGAGEMENT_QUALITY_METRICS_INFINITE_KEY,
  },
}

export type { AutoGtBreakdown, AutoGtBreakdownVote, AutoGtBreakdownVoteOrigin } from './getAutoGtBreakdown'
export type { EngagementOrganizationResponse } from './getOrganization'

export type {
  AutoGtTimeline,
  AutoGtCandidate,
  AutoGtContributor,
  AutoGtLineage,
  AutoGtOperator,
  AutoGtTimelineEvent,
  AutoGtPublicationProgress,
  AutoGtPublicationTarget,
} from './getAutoGtTimeline'

export type { RejectionReasonCatalogItem, RejectionReasonCatalogResponse } from './useRejectionReasons'
